module.exports = __webpack_public_path__ + "static/media/26GalleryPuppets.458fdc91.jpeg";